import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @record.durationSeconds}}\n  {{format-duration @record.durationSeconds \'SECOND\'}}\n{{else}}\n  -\n{{/if}}")